import { makeStyles } from "@mui/styles";
import { Container } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 46,
    paddingLeft: 32,
    paddingRight: 32,
    maxWidth: "1280px",
    marginBottom: "105px",
    // Commenting out because they mentioned in doc padding should be 30px on both sides
    // [theme.breakpoints.up("lg")]: {
    //   paddingLeft: 86,
    //   paddingRight: 86,
    // },
    [theme.breakpoints.down("md")]: {
      paddingLeft: 12,
      paddingRight: 12,
    },
  },
}));

interface PageContainerProps {
  children?: any;
}

export const PageContainer = (props: PageContainerProps) => {
  const classes = useStyles();

  return (
    <Container
      disableGutters
      maxWidth={false}
      className={classes.root}
      role="main"
      id="main"
      component="main">
      {props.children}
    </Container>
  );
};
